interface IIconCloseProps {
  className?: string;
  width?: string;
  height?: string;
  fill?: string;
}
const IconClose = ({
  className = '',
  fill = '#FFF',
  height = '30',
  width = '30',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      className={className}
    >
      <path
        d="M21.7027 7.00438L14.8492 13.8579L7.99575 7.00438L6.8535 8.14662L13.707 15.0001L6.8535 21.8536L7.99575 22.9959L14.8492 16.1424L21.7027 22.9959L22.845 21.8536L15.9915 15.0001L22.845 8.14662L21.7027 7.00438Z"
        fill={fill}
      />
    </svg>
  );
};

export default IconClose;
